import React from 'react';

import { Dialog } from 'ui';

import './_feedback-status-modal.scss';

/**
 * FeedbackStatusModal - Chromeless confirmation card shown after a feedback
 * submission: centered StudyBuddy mascot, bold title and one-line description,
 * with no header or footer (dismissed via backdrop/ESC), matching the Figma
 * "feedback > popup > éxito / error" frames. The mascot comes from the
 * per-tenant `--tangerine-ai-bot-*` CSS vars (`public/css/styles.css`):
 * "happy" on success, "disconnected" (X eyes) on error.
 */

type FeedbackStatusModalProps = {
  description: string;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  variant: 'success' | 'error';
};

function FeedbackStatusModal({ description, isOpen, onClose, title, variant }: Readonly<FeedbackStatusModalProps>): JSX.Element {
  return (
    <Dialog ariaLabel={title} className="feedback-status-modal" isHeaderHidden isOpen={isOpen} onClose={onClose} size="s">
      <div className="feedback-status-modal__content">
        <span aria-hidden="true" className={`feedback-status-modal__mascot feedback-status-modal__mascot--${variant}`} />
        <h3 className="feedback-status-modal__title">{title}</h3>
        {/* role="status" so assistive tech announces the outcome when the chromeless dialog opens */}
        <p className="feedback-status-modal__description" role="status">
          {description}
        </p>
      </div>
    </Dialog>
  );
}

export default FeedbackStatusModal;
